import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Emails from '@/pages/emails';

export default function Routes() {
  return (
    <Switch>
      <Route exact path="/" component={Emails} />
    </Switch>
  );
}
